import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="bg-cream sticky top-0 z-50 shadow-sm" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex justify-between h-16" data-id="element-140">
          <div className="flex items-center" data-id="element-141">
            <div className="flex-shrink-0 flex items-center" data-id="element-142">
              <Link to="/" className="text-burgundy font-display text-2xl font-bold" data-id="element-143">
                Chef<span className="text-sage" data-id="element-144">Chat</span>
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8" data-id="element-145">
            <a href="#features" className="text-charcoal hover:text-burgundy transition-colors" data-id="element-146">
              Features
            </a>
            <a href="#how-it-works" className="text-charcoal hover:text-burgundy transition-colors" data-id="element-147">
              How It Works
            </a>
            <a href="#testimonials" className="text-charcoal hover:text-burgundy transition-colors" data-id="element-148">
              Testimonials
            </a>
            <a href="#pricing" className="text-charcoal hover:text-burgundy transition-colors" data-id="element-149">
              Pricing
            </a>
            <Link to="/login" className="bg-cream text-burgundy border-2 border-burgundy hover:bg-burgundy hover:text-cream transition-colors px-4 py-2 rounded-md font-medium" data-id="element-150">
              Login
            </Link>
            <Link to="/signup" className="bg-burgundy text-cream hover:bg-burgundy/90 transition-colors px-4 py-2 rounded-md font-medium" data-id="element-151">
              Start Free Trial
            </Link>
          </div>
          <div className="md:hidden flex items-center" data-id="element-152">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-charcoal p-2" data-id="element-153">
              {isMenuOpen ? <XIcon size={24} data-id="element-154" /> : <MenuIcon size={24} data-id="element-155" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-cream" data-id="element-156">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-157">
            <a href="#features" className="block px-3 py-2 text-charcoal hover:text-burgundy" data-id="element-158">
              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 text-charcoal hover:text-burgundy" data-id="element-159">
              How It Works
            </a>
            <a href="#testimonials" className="block px-3 py-2 text-charcoal hover:text-burgundy" data-id="element-160">
              Testimonials
            </a>
            <a href="#pricing" className="block px-3 py-2 text-charcoal hover:text-burgundy" data-id="element-161">
              Pricing
            </a>
            <div className="flex flex-col space-y-2 px-3 py-2" data-id="element-162">
              <Link to="/login" className="bg-cream text-burgundy border-2 border-burgundy hover:bg-burgundy hover:text-cream transition-colors px-4 py-2 rounded-md font-medium text-center" data-id="element-163">
                Login
              </Link>
              <Link to="/signup" className="bg-burgundy text-cream hover:bg-burgundy/90 transition-colors px-4 py-2 rounded-md font-medium text-center" data-id="element-164">
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
};
export default Navbar;